var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 14,
    viewBox: "0 0 9 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.38672 6.23828C3.69922 6.53125 4.07031 6.67773 4.5 6.67773C4.92969 6.67773 5.29102 6.53125 5.58398 6.23828C5.89648 5.92578 6.05273 5.55469 6.05273 5.125C6.05273 4.69531 5.89648 4.33398 5.58398 4.04102C5.29102 3.72852 4.92969 3.57227 4.5 3.57227C4.07031 3.57227 3.69922 3.72852 3.38672 4.04102C3.09375 4.33398 2.94727 4.69531 2.94727 5.125C2.94727 5.55469 3.09375 5.92578 3.38672 6.23828ZM1.39453 2.04883C2.25391 1.18945 3.28906 0.759766 4.5 0.759766C5.71094 0.759766 6.73633 1.18945 7.57617 2.04883C8.43555 2.88867 8.86523 3.91406 8.86523 5.125C8.86523 5.73047 8.70898 6.42383 8.39648 7.20508C8.10352 7.98633 7.74219 8.71875 7.3125 9.40234C6.88281 10.0859 6.45312 10.7305 6.02344 11.3359C5.61328 11.9219 5.26172 12.3906 4.96875 12.7422L4.5 13.2402C4.38281 13.1035 4.22656 12.9277 4.03125 12.7129C3.83594 12.4785 3.48438 12.0293 2.97656 11.3652C2.46875 10.6816 2.01953 10.0273 1.62891 9.40234C1.25781 8.75781 0.916016 8.03516 0.603516 7.23438C0.291016 6.43359 0.134766 5.73047 0.134766 5.125C0.134766 3.91406 0.554688 2.88867 1.39453 2.04883Z",
    fill: "#FE0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.10287317c48a54337cb88461ecacc95c.svg";
export { ForwardRef as ReactComponent };